import Vue from 'vue'

export default {
  enableLoader(state) {
    state.loading = true
  },
  disableLoader(state) {
    state.loading = false
  },
  setForms(state, forms) {
    state.forms = forms
  },
  setNotification(state, notification) {
    state.notification = notification
  },
  setSendError(state, error) {
    state.sendError = error
  }
}



// WEBPACK FOOTER //
// ./client/store/mutations.js